<div class="pickup-dates" data-testid="pickup-dates-section">
  <puro-typography variant="h5-semibold" component="h3" class="pickup-dates__title">
    {{ 'createShipment.serviceStep.pickupDropOff.datesTitle' | translate }}
  </puro-typography>

  @if (loading()) {
    <output class="pickup-dates__status">
      {{ 'createShipment.serviceStep.pickupDropOff.datesLoading' | translate }}
    </output>
  } @else if (errorMessage()) {
    <puro-alert severity="error">{{ errorMessage() }}</puro-alert>
  } @else if (dates().length === 0) {
    <puro-alert severity="warning">
      {{ 'createShipment.serviceStep.pickupDropOff.datesEmpty' | translate }}
    </puro-alert>
  } @else {
    @if (noticeMessage()) {
      <puro-alert severity="warning" data-testid="pickup-dates-notice">{{
        noticeMessage()
      }}</puro-alert>
    }

    <fieldset class="pickup-dates__radios">
      <legend class="pickup-dates__legend">
        {{ 'createShipment.serviceStep.pickupDropOff.datesTitle' | translate }}
      </legend>
      @for (option of dates(); track option.date) {
        <label class="pickup-dates__option">
          <input
            class="pickup-dates__native-radio"
            type="radio"
            name="pickupDate"
            [value]="option.date"
            [checked]="selectedDate() === option.date"
            (change)="onDateSelect(option.date)"
          />
          <span
            class="pickup-dates__radio"
            [class.pickup-dates__radio--checked]="selectedDate() === option.date"
            aria-hidden="true"
          ></span>
          <span class="pickup-dates__label">{{ option.label }}</span>
        </label>
      }
    </fieldset>
  }
</div>
